import { useTranslation } from 'react-i18next'

import { Namespace } from '~/i18n'
import { H2, TextL } from '~/tenset-components'
import { GetListedButton } from '~/components/utils'

export default function IsYourProjectNextGemBlock() {
  const { t } = useTranslation(Namespace.COMMON)

  return (
    <div className="flex flex-col gap-6 md:items-center md:text-center">
      <div className="flex flex-col gap-4">
        <header>
          <H2 isBold>{t('common:is-your-project-next-gem.title')}</H2>
        </header>

        <main className="max-w-[800px]">
          <TextL>{t('common:is-your-project-next-gem.description')}</TextL>
        </main>
      </div>

      <GetListedButton />
    </div>
  )
}
